import TopFiveAsha from "./TopFiveAsha/TopFiveAsha";
import React, { useEffect, useState, lazy, Suspense } from "react";
import ModalHeader from "../../../Components/Header/ModalHeader";
import AshaIndividualView from "../AshaAnmSection/AshaIndividualView/AshaIndividualView";
import { Dialog } from "primereact/dialog";
import AshaDetailsView from "./AshaDetailsView/AshaDetailsTable";
import AshaIncentiveView from "./AshaIncentiveView/AshaIncentiveView";
import "./AshaAnmSectionView.scss";
import * as ashaanmselector from "../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionSelectors";
import TotalActiveInactiveAshaAnm from "./TotalActiveInactiveAshaAnm/TotalActiveInactiveAshaAnm";
import AshaAnmModal from "./TotalActiveInactiveAshaAnm/AshaAnmModal";
import AshaAnmDetailsView from "./TotalActiveInactiveAshaAnm/AshaAnmDetailsView/AshaAnmDetailsView";
import { useTranslation } from "react-i18next";
import { fetchActiveInactiveCardDataCount } from "../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions";
import { useDispatch, useSelector } from "react-redux";
import * as dashboardselector from "../../../Store/Dashboard/DashboardSelectors";
import AshaDeployedByRegions from "./AshaDeployedByRegion/AshaDeployedByRegions";
import AshaDepModal from "./AshaDeployedByRegion/AshaDepModal";
import GetAreaId from "../../../Shared/Utils/getAreaId";
const NumberOfAshas = lazy(() =>
  import("../../../Shared/Component/NumberOfAshas")
);
const AshaAnmSectionView = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [aName, setAName] = useState("");
  const [isAct, setIsActive] = useState(false);
  const [modeRole, setModeRole] = useState("");
  const [ashaAnmIndividual, setAshaAnmIndividual] = useState(false);
  const [chosenAshaId, setChosenAshaId] = useState("");
  const [incentiveVisible, setIncentiveVisible] = useState(false);
  const [ashaDetailVisible, setAshaDetailVisible] = useState(false);
  const [ashaanmDetailVisible, setAshaAnmDetailVisible] = useState(false);
  const [splitName, setSplitName] = useState([]);
  const [chosenIndex, setChosenIndex] = useState(0);
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);
  const [deployedByRegionVisible, setAshaDeployedByRegionVisible] =
    useState(false);
  const areaType = useSelector(dashboardselector.getGlobalAreaType);
  const dispatch = useDispatch();
  const activeInactiveAshaAnmCount = useSelector(
    ashaanmselector.getActiveInactiveAshaAnmCount
  );
  const roles = sessionStorage.getItem("userRole");
  let areaId = GetAreaId(areaType);
  const ashasData = useSelector(ashaanmselector.getTotalAshaAnmTableList);
  const [, setactiveList_asha] = useState([]);
  const [, setinactiveList_asha] = useState([]);
  const [, setactiveList_anm] = useState([]);
  const [, setinactiveList_anm] = useState([]);
  const [, setactiveList_af] = useState([]);
  const [, setinactiveList_af] = useState([]);
  useEffect(() => {
    dispatch(fetchActiveInactiveCardDataCount(areaId, roles));
  }, [dispatch, areaId, roles]);
  const closeDialog = () => {
    setVisible(false);
    setIncentiveVisible(false);
    setAshaDetailVisible(false);
    setAshaAnmDetailVisible(false);
    setAshaDeployedByRegionVisible(false);
    setAshaAnmIndividual(false);
  };

  const handleAshaSelect = (selectedAshaId, name, isActive, index) => {
    setVisible(true);
    setChosenAshaId(selectedAshaId);
    setChosenIndex(index);
    setAName(name);
    setIsActive(true);
  };
  const handleIncentiveSelect = (name, month, year) => {
    setIncentiveVisible(true);
    setSplitName(name);
    setSelectedMonths(month);
    setSelectedYears(year);
  };
  const handleAshaDetails = () => {
    setAshaDetailVisible(true);
  };
  const handleDepByRegionSelect = (name) => {
    setAshaDeployedByRegionVisible(true);
    setSplitName(name);
  };

  const handleAshaAnmDetails = (index) => {
    setChosenIndex(index);
    setAshaAnmDetailVisible(true);
  };
  const openAsha = (mode, index) => {
    setAshaAnmIndividual(true);
    setChosenIndex(index);
    setModeRole(mode);
  };

  useEffect(() => {
    const createLists = (ashaList, role) => {
      const activeList = [];
      const inactiveList = [];
      ashaList.forEach((item) => {
        if (item.role === role) {
          if (item.isActive) {
            activeList.push(item);
          } else {
            inactiveList.push(item);
          }
        }
      });
      return { activeList, inactiveList };
    };
    function checkAshasData(ashasData) {
      return !!(ashasData && ashasData.ashaList);
    }
    if (checkAshasData(ashasData)) {
      const { ashaList } = ashasData;
      const { activeList: activeList_asha, inactiveList: inactiveList_asha } =
        createLists(ashaList, "ASHA");
      const { activeList: activeList_anm, inactiveList: inactiveList_anm } =
        createLists(ashaList, "ANM");
      const { activeList: activeList_af, inactiveList: inactiveList_af } =
        createLists(ashaList, "AF");

      setactiveList_asha(activeList_asha);
      setinactiveList_asha(inactiveList_asha);
      setactiveList_anm(activeList_anm);
      setinactiveList_anm(inactiveList_anm);
      setactiveList_af(activeList_af);
      setinactiveList_af(inactiveList_af);
    }
  }, [ashasData]);
  
  return (
    <>
      <div className="grid">
        <div className="xs:col-12 sm:col-12 md:col-7">
          <div
            className="text-center border-round-sm"
            data-test-id="number-of-ashas-comp"
          >
            <Suspense fallback={<div></div>}>
              <NumberOfAshas onBarClick={handleIncentiveSelect} />
            </Suspense>
          </div>
        </div>
        <div className="sm:col-12 md:col-5">
          <div
            className="text-center border-round-sm"
            data-test-id="top-five-asha-comp"
          >
            <TopFiveAsha
              onAshaSelect={handleAshaSelect}
              ashaDetails={handleAshaDetails}
            />
          </div>
        </div>
        <div
          className="sm:col-12 md:col-5"
          data-test-id="total-active-inactive-asha-anm"
        >
          <div className="card-container-asha-anm">
            <TotalActiveInactiveAshaAnm
              status="active"
              title={t("active")}
              ashaanmDetails={() => handleAshaAnmDetails(0)}
              ashaModal={openAsha}
              totalCount={
                activeInactiveAshaAnmCount &&
                activeInactiveAshaAnmCount.totalActive
              }
              ashaCount={
                activeInactiveAshaAnmCount &&
                activeInactiveAshaAnmCount.ActiveAshaCount
              }
              anmCount={
                activeInactiveAshaAnmCount &&
                activeInactiveAshaAnmCount.activeANMCount
              }
              afCount={
                activeInactiveAshaAnmCount &&
                activeInactiveAshaAnmCount.activeAFCount
              }
            />
            <TotalActiveInactiveAshaAnm
              status="inactive"
              title={t("inactive")}
              ashaanmDetails={() => handleAshaAnmDetails(1)}
              ashaModal={openAsha}
              totalCount={
                activeInactiveAshaAnmCount &&
                activeInactiveAshaAnmCount.totalInactive
              }
              ashaCount={
                activeInactiveAshaAnmCount &&
                activeInactiveAshaAnmCount.inActiveAshaCount
              }
              anmCount={
                activeInactiveAshaAnmCount &&
                activeInactiveAshaAnmCount.inActiveANMCount
              }
              afCount={
                activeInactiveAshaAnmCount &&
                activeInactiveAshaAnmCount.inActiveAFCount
              }
            />
            <AshaDeployedByRegions
              onBarClick={handleDepByRegionSelect}
            ></AshaDeployedByRegions>
          </div>
        </div>
      </div>
      <Dialog
        className="cockpit-dialog"
        visible={visible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setVisible(false)}
        closeOnEscape={false}
        data-testid="dialog"
        header={
          <ModalHeader onClose={closeDialog} backText={t("BacktoTable")} />
        }
      >
        <AshaIndividualView
          ashaId={chosenAshaId}
          chosenActiveIndex={chosenIndex}
          name={aName}
          isStatus={isAct}
          data-testid="asha-individual-view"
        />
      </Dialog>
      <Dialog
        className="cockpit-dialog"
        visible={incentiveVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setIncentiveVisible(false)}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("backtodashboard")} />
        }
      >
        <AshaIncentiveView
          split={splitName}
          handleAshaClick={handleAshaSelect}
          selectedMonth={selectedMonths}
          selectedYear={selectedYears}
        />
      </Dialog>
      <Dialog
        className="cockpit-dialog"
        visible={ashaDetailVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setAshaDetailVisible(false)}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("backtodashboard")} />
        }
      >
        <AshaDetailsView handleAshaClick={handleAshaSelect} />
      </Dialog>
      <Dialog
        className="cockpit-dialog"
        visible={ashaanmDetailVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setAshaAnmDetailVisible(false)}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("backtodashboard")} />
        }
      >
        <AshaAnmDetailsView index={chosenIndex} totalActive={activeInactiveAshaAnmCount && activeInactiveAshaAnmCount.totalActive} totalInactive={activeInactiveAshaAnmCount && activeInactiveAshaAnmCount.totalInactive} />
      </Dialog>
      <Dialog
        className="cockpit-dialog"
        visible={ashaAnmIndividual}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setAshaAnmIndividual(false)}
        closeOnEscape={false}
        header={
          <ModalHeader
            onClose={closeDialog}
            backText={t("backtodashboard")}
            data-testid="modal-header"
          />
        }
      >
        <AshaAnmModal mode={modeRole} index={chosenIndex} ashaCount={
                activeInactiveAshaAnmCount && (activeInactiveAshaAnmCount.ActiveAshaCount + activeInactiveAshaAnmCount.inActiveAshaCount)
              }
              anmCount={
                activeInactiveAshaAnmCount && (activeInactiveAshaAnmCount.activeANMCount + activeInactiveAshaAnmCount.inActiveANMCount)
              }
              afCount={
                activeInactiveAshaAnmCount && (activeInactiveAshaAnmCount.activeAFCount + activeInactiveAshaAnmCount.inActiveAFCount)
              }
              activeAshaCount={
                activeInactiveAshaAnmCount && activeInactiveAshaAnmCount.ActiveAshaCount
              }
              activeAnmCount={
                activeInactiveAshaAnmCount && activeInactiveAshaAnmCount.activeANMCount
              }
              activeAfCount={
                activeInactiveAshaAnmCount && activeInactiveAshaAnmCount.activeAFCount
              } />
      </Dialog>
      <Dialog
        className="cockpit-dialog"
        visible={deployedByRegionVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setAshaDeployedByRegionVisible(false)}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("backtodashboard")} />
        }
      >
        <AshaDepModal split={splitName} handleAshaClick={handleAshaSelect} />
      </Dialog>
    </>
  );
};
export default AshaAnmSectionView;
